import React, {useEffect, useState} from "react";
import moment from "moment-timezone";
import {Typography} from "@mui/material";
import {styled} from "@mui/system";

const NUMBER_OF_MILLISECONDS_IN_A_SECOND = 1000;
const CURRENT_TIME_FORMAT = "hh:mm A";

export default function CurrentTimeDisplay() {
  const [currentTime, setCurrentTime] = useState("");

  const CurrentTimeLabel = styled(Typography)(({theme}) => ({
    alignSelf: 'flex-end',
    fontSize: '1.5rem',
    marginBottom: '-0.8rem',
    marginTop: '0.3rem'
  }));

  useEffect(() => {
    const intervalId = setInterval(updateCurrentTime, NUMBER_OF_MILLISECONDS_IN_A_SECOND);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const updateCurrentTime = () => {
    setCurrentTime(moment().format(CURRENT_TIME_FORMAT));
  };

  return <CurrentTimeLabel>{currentTime}</CurrentTimeLabel>;
}
